import { addUserListener, addUserLogoutListener, removeUserListener, removeUserLogoutListener, triggerPageEvent, triggerUserLogOutEvent } from "eventFunctions"
import UserContext from "global_state/context/UserContext"
import { useContext, useEffect} from "react"
import PageContext from "../global_state/context/PageContext"
import SCSS from '../assets/scss/App.module.scss';
import LogOutUserService from "services/LogOutUserService";

import content from 'languages/SubMenu.json'

const SubMenu = () => {
    const {page, dispatchPage}  = useContext(PageContext)
    const {user, dispatchUser} = useContext(UserContext)

    let lang = page.settings.lang
    const handleDetailAccount = (e) => {

        sessionStorage.setItem('xf_active_page', JSON.stringify('account_detail'));
        triggerPageEvent()
                
        // let wp_page = process.env.REACT_APP_WP_PAGE || 'app'
        let wp_page = process.env["REACT_APP_WP_PAGE_"+lang] || 'app'

        let xf_page = 'account_detail';
        // let search_params = new URLSearchParams({
        //   xf_page: xf_page
        // })

        if (!window.location.pathname.includes(wp_page)) {
            let url_object = new URL(window.location.href)
            url_object.pathname = wp_page
            
            if (url_object.searchParams.has('xf_page')) {
                url_object.searchParams.set('xf_page', xf_page)
            } else {
                url_object.searchParams.append('xf_page', xf_page)
            }
            
            // url_object.searchParams.append('xf_page', xf_page)

            window.location.href = url_object.href
        }    

        document.getElementById('mp-menu-trigger')?.dispatchEvent(new Event('click'))        
        
    }
    const handleLogOut = async () => {
        // sessionStorage.setItem('xf_active_page', JSON.stringify('account_detail'));
        // sessionStorage.removeItem('xf_active_user');
        // sessionStorage.removeItem('xf_active_page');
        // triggerPageEvent()
        let logout = await LogOutUserService(user.client_id, user.connection_id)

        triggerUserLogOutEvent(dispatchUser)
    }

    const renderSubMenu = () => {
        // console.log("render Sub Menu".toUpperCase());
        
        // console.log(user);
        
        if (user.client_id == null) {
            // console.log("logout");
            
            let sub_menu_ul = document.getElementsByClassName('xplore_react_reservations_submenu')
            for (let index = 0; index < sub_menu_ul.length; index++) {
                const element = sub_menu_ul[index].closest('ul') as HTMLElement;
                // console.log(element);
                
                element.classList.add('empty_submenu')
            }
            // console.log(sub_menu_ul);
            return (
                <div className="empty"></div>
            )
        }

        let sub_menu_ul = document.getElementsByClassName('xplore_react_reservations_submenu')
        for (let index = 0; index < sub_menu_ul.length; index++) {
            const element = sub_menu_ul[index].closest('ul') as HTMLElement;
            element.classList.remove('empty_submenu')
        }
        // console.log(sub_menu_ul);
        
        return (
            <div className={SCSS.submenu}>
                <ul>
                    <li>
                        {/* TODO: on click switch xf_page to account_detail => create account detail and it edit */}
                        <a onClick={e => handleDetailAccount(e)}>{content[lang].my_account}</a>
                    </li>
                    <li>
                        <button className={[SCSS.button, SCSS.red].join(" ")} onClick={handleLogOut}>{content[lang].log_out}</button>
                    </li>
                </ul>
            </div>
        )
    }

    useEffect(() => {
        addUserListener(dispatchUser)
        addUserLogoutListener(user, dispatchUser)

        return () => {
            removeUserListener(dispatchUser)
            removeUserLogoutListener(user, dispatchUser)

        }
    }, [])

    return (
        <>
            {renderSubMenu()}   
        </>
        
    )
}

export default SubMenu